import { LuCpu } from 'react-icons/lu'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import type { SxProps, Theme } from '@mui/material/styles'
import type { NodeCompute } from '../utilities/computeNode'

type Props = {
  compute: NodeCompute
  sx?: SxProps<Theme>
}

/**
 * The compute badge on the node page header (app#329). The graph, the map and the node list show
 * a node with compute as the noBGP cloud mark after its name (nobgp-router#2010), with the same
 * tooltip line.
 *
 * Same data everywhere (`hooks/useComputeNodes`), so the surfaces cannot disagree about which
 * node has compute or when it stops. The chip says `Compute · small`; the time is in the tooltip.
 */
export default function ComputeBadge({ compute, sx }: Props) {
  return (
    <Tooltip title={compute.label}>
      <Chip
        icon={<LuCpu />}
        label={`Compute · ${compute.shape}`}
        size="small"
        variant="outlined"
        color="secondary"
        sx={sx}
      />
    </Tooltip>
  )
}
